import { type ResultOf } from '@graphql-typed-document-node/core'
import { atomWithReset } from 'jotai/utils'

import { graphql } from '~/gql'
import { type CustomerAnalysisPage_TabulationMutationMutationVariables as MutationVariables } from '~/gql/graphql'

export const isTabulationReadyAtom = atomWithReset(false)
export const isPendingTabulationAtom = atomWithReset(false)

const tabulationQueryDataFragment = graphql(`
  fragment CustomerAnalysisPage_TabulationQueryData on CountBrands9segsInBrandGroupResult {
    brandGroupId
    result {
      id
      brandGroupId
      name
      number
      result {
        count
        segmentNumber
      }
    }
  }
`)

export const tabulationQueryDataAtom = atomWithReset<ResultOf<
  typeof tabulationQueryDataFragment
> | null>(null)

export const lastTabulatedVariablesAtom =
  atomWithReset<MutationVariables | null>(null)
